module.exports = __webpack_public_path__ + "img/die-linke-logo.bdce4ad9.svg";